import { getNavigationFeaturesList, getNavigationList } from "@/api/navigation-requests"
import { useQuery} from "@tanstack/react-query";
import { dayjs } from "../lib/dayjs";
import { dashboardConfig } from "../config/dashboard";

export function useNavigationList(deviceUuid?: string) {

    return useQuery({
        queryKey: ["navigation-list", deviceUuid],
        queryFn: ({ signal }) => {
            return getNavigationList(deviceUuid!, signal);
        },
        enabled: Boolean(deviceUuid),
    });
}

//export function useNavigationFeaturesList(deviceUuid?: string, featureRef?: string) {

//    return useQuery({
//        queryKey: ["navigation-feature", deviceUuid, featureRef],
//        queryFn: ({ signal }) => {
//            return getNavigationFeaturesList(deviceUuid!, featureRef!, signal);
//        },
//        enabled: Boolean(
//            deviceUuid &&
//            featureRef
//        ),
//    })
//}
export function useNavigationFeaturesList(deviceUuid?: string,featureRef?: string,deviceDataHours?: number) {
    return useQuery({
        queryKey: ["navigation-feature",deviceUuid,featureRef,deviceDataHours],

        queryFn: ({ signal }) => {
            const to = dayjs();

            const dateRange =
                deviceDataHours === undefined
                    ? undefined
                    : {
                        from: to
                            .subtract(deviceDataHours, "hour")
                            .toISOString(),
                        to: to.toISOString(),
                    };

            return getNavigationFeaturesList(
                deviceUuid!,
                featureRef!,
                dateRange,
                signal
            );
        },

        enabled: Boolean(deviceUuid && featureRef),
        refetchInterval: dashboardConfig.api.refetchInterval * 4,
        refetchIntervalInBackground: false,
        refetchOnWindowFocus: false,
        meta: {
            persist: false,
        },
    });
}
